import React, {useState, useEffect } from "react";
import { connect } from "react-redux";
import CardSlider from '../CardSlider/CardSlider';
import SwiperCore, { Swiper, Autoplay, Navigation, Pagination } from 'swiper';
import Slider from "react-slick";

const CardBlock = ({...props}) => {
    useEffect(()=>{        
        var swiper = new Swiper('.swiper-container', {
            autoplay: {
                delay: 2500,
            },
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            // on: {
            //     resize: function () {
            //         swiper.changeDirection('horizontal');
            //     }
            // },
            breakpoints: {
                // when window width is >= 640px
                640: {
                  slidesPerView: 3
                }
              }
        });
    }, [])

    // Config Swiper
    Swiper.use([Navigation, Pagination]);
    SwiperCore.use([Autoplay]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    // Get Data
    let list = [];
    if(props.list !== undefined){
        list = props.list        
    }

    const renderCards = () => (
        list.length > 0 ?
        list.map((card,index) => (
            <CardSlider key={index} {...card} />
        )) : null
    )

    return (
        <>
        <div className="container">
            <div className='row' style={{ background:`linear-gradient(${props.templates.templates.templateProperties.background_card_block_slider_first}, ${props.templates.templates.templateProperties.background_card_block_slider_second})`, margin:"5% 0 auto", borderRadius:10 }}>
                <h6 style={{ color:`${props.templates.templates.templateProperties.text_color_card_block_slider}`, fontSize:20, padding: 20, margin:"0 auto" }}>{ props.title }</h6>
                <div className="col">
                    <div className="swiper-container">
                        <div className="swiper-wrapper">
                            {renderCards(props.list)}
                        </div>
                        <div className="swiper-pagination"></div>
                    </div>
                </div>            
            </div>
        </div>
        </>
    )
};

const mapStateToProps = (state) => {
    return {
        templates: state.templates,
    };
};
  
export default connect(mapStateToProps)(CardBlock);